import { Main } from '../../components'

const TermsOfUse = () => {
  return (
    <Main>
      <div>TermsOfUse!</div>
    </Main>
  )
}

export default TermsOfUse
